<template>
  <van-nav-bar
    :title="title"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  />
</template>
<script>
  export default {
    props: {
      title:""
    },
    methods:{
      onClickLeft(){
        this.$router.back()
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/ .van-nav-bar__content{
    .van-nav-bar__title{
      font-size: 16px;
    }
  }
/deep/.van-icon-arrow-left::before{
  color: #333;
  font-size: 16px;
}
/deep/.van-nav-bar__text{
  color: #333 !important;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/back.vue